
import React from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

interface EmptyPollStateProps {
  showClosed: boolean;
  onCreatePoll: () => void;
  isAuthenticated: boolean;
}

const EmptyPollState: React.FC<EmptyPollStateProps> = ({ 
  showClosed, 
  onCreatePoll, 
  isAuthenticated 
}) => {
  return (
    <div className="py-8 text-center text-gray-500">
      <CheckCircle2 className="mx-auto h-12 w-12 text-gray-300 mb-2" />
      <p>No polls available{!showClosed ? " yet" : " that are active"}.</p>
      {isAuthenticated && (
        <Button 
          onClick={onCreatePoll} 
          variant="link" 
          className="mt-2"
        >
          Create the first poll
        </Button>
      )}
    </div>
  );
};

export default EmptyPollState;
